export class MasterRolePermission {

  rolePermission: string;

  constructor(rolePermission: string) {
    this.rolePermission = rolePermission;
  }
  static LiveViewParkfly: MasterRolePermission = new MasterRolePermission("View Park & Fly");
  static ViewAlarmMonitor: MasterRolePermission = new MasterRolePermission("View Alarm Monitor");
  static ViewOccupancy: MasterRolePermission = new MasterRolePermission("View Occupancy");
  static ViewParkingStations: MasterRolePermission = new MasterRolePermission("View Parking Stations");
  static ViewFastagReconciliations: MasterRolePermission = new MasterRolePermission("View Fastag Reconciliations");
  static ViewANPRViewStreaming: MasterRolePermission = new MasterRolePermission("View ANPR View Streaming");
  static ViewGeolocalization: MasterRolePermission = new MasterRolePermission("View Geolocalization");

  static ViewReportCreate: MasterRolePermission = new MasterRolePermission("View Reports");
  static ViewRepository: MasterRolePermission = new MasterRolePermission("View Repository");
  static ViewScheduling: MasterRolePermission = new MasterRolePermission("View Scheduling");

  static ViewCustomers: MasterRolePermission = new MasterRolePermission("View Customers");
  static ManageCustomers: MasterRolePermission = new MasterRolePermission("Manage Customers");
  static ViewProductProfiles: MasterRolePermission = new MasterRolePermission("View Product Profiles");
  static ManageProductProfiles: MasterRolePermission = new MasterRolePermission("Manage Product Profiles");
  static ViewTimeSlots: MasterRolePermission = new MasterRolePermission("View Time Slots");
  static ManageTimeSlots: MasterRolePermission = new MasterRolePermission("Manage Time Slots");
  static ViewGroup: MasterRolePermission = new MasterRolePermission("View Group");
  static ManageGroup: MasterRolePermission = new MasterRolePermission("Manage Group");
  static ViewRates: MasterRolePermission = new MasterRolePermission("View Rates");
  static ManageRates: MasterRolePermission = new MasterRolePermission("Manage Rates");
  static ViewAccessPolicies: MasterRolePermission = new MasterRolePermission("View Access Policies");
  static ManageAccessPolicies: MasterRolePermission = new MasterRolePermission("Manage Access Policies");
  static ViewBusinessCustomer: MasterRolePermission = new MasterRolePermission("View Business Customer");
  static ManageBusinessCustomer: MasterRolePermission = new MasterRolePermission("Manage Business Customer");
  static ViewRatesProfile: MasterRolePermission = new MasterRolePermission("View Rates Profile");
  static ManageRatesProfile: MasterRolePermission = new MasterRolePermission("Manage Rates Profile");
  static ViewUserCategory: MasterRolePermission = new MasterRolePermission("View User Category");
  static ManageUserCategory: MasterRolePermission = new MasterRolePermission("Manage User Category");
  static ViewCardPool: MasterRolePermission = new MasterRolePermission("View Card Pool");
  static ManageCardPool: MasterRolePermission = new MasterRolePermission("Manage Card Pool");
  static ViewVoucher: MasterRolePermission = new MasterRolePermission("View Voucher");
  static ManageVoucher: MasterRolePermission = new MasterRolePermission("Manage Voucher");
  static ViewDiscount: MasterRolePermission = new MasterRolePermission("View Discount");
  static ManageDiscount: MasterRolePermission = new MasterRolePermission("Manage Discount");
  static ViewOnlineBooking: MasterRolePermission = new MasterRolePermission("View Online Booking");
  static ManageOnlineBooking: MasterRolePermission = new MasterRolePermission("Manage Online Booking");
  static ViewAlerts: MasterRolePermission = new MasterRolePermission("View Alerts");
  static ManageAlerts: MasterRolePermission = new MasterRolePermission("Manage Alerts");
  static ViewParksFly: MasterRolePermission = new MasterRolePermission("View Parks & Fly");
  static ManageParksFly: MasterRolePermission = new MasterRolePermission("Manage Parks & Fly");
  static ViewBlackListWhiteList: MasterRolePermission = new MasterRolePermission("View Black List/White List");
  static ManageBlackListWhiteList: MasterRolePermission = new MasterRolePermission("Manage Black List/White List");
  static ViewStationGroup: MasterRolePermission = new MasterRolePermission("View Station Group");
  static ManageStationGroup: MasterRolePermission = new MasterRolePermission("Manage Station Group");

  static ViewSystem: MasterRolePermission = new MasterRolePermission("View System");
  static ManageSystem: MasterRolePermission = new MasterRolePermission("Manage System");
  static ViewLogs: MasterRolePermission = new MasterRolePermission("View Logs");
  static ManageLogs: MasterRolePermission = new MasterRolePermission("Manage Logs");
  static ViewAreaCount: MasterRolePermission = new MasterRolePermission("View Area Count");
  static ManageAreaCount: MasterRolePermission = new MasterRolePermission("Manage Area Count");
  static ViewDevices: MasterRolePermission = new MasterRolePermission("View Devices");
  static ManageDevices: MasterRolePermission = new MasterRolePermission("Manage Devices");
  static ViewUserOperators: MasterRolePermission = new MasterRolePermission("View User/Operators");
  static ManageUserOperators: MasterRolePermission = new MasterRolePermission("Manage User/Operators");

  static ViewAccount: MasterRolePermission = new MasterRolePermission("View Account");
  static ManageAccount: MasterRolePermission = new MasterRolePermission("Manage Account");
  static ViewContracts: MasterRolePermission = new MasterRolePermission("View Contracts");
  static ManageContracts: MasterRolePermission = new MasterRolePermission("Manage Contracts");
  static ViewRoles: MasterRolePermission = new MasterRolePermission("View Roles");
  static ManageRoles: MasterRolePermission = new MasterRolePermission("Manage Roles");

  static ViewCabGroup: MasterRolePermission = new MasterRolePermission("View Cab Group");
  static ManageCabGroup: MasterRolePermission = new MasterRolePermission("Manage Cab Group");
 

  static ViewCabCards: MasterRolePermission = new MasterRolePermission("View Cab Cards");
  static ManageCabCards: MasterRolePermission = new MasterRolePermission("Manage Cab Cards");

  static ViewLogFileCnvrtCSV: MasterRolePermission = new MasterRolePermission("View Log File Cnvrt CSV");
  static ManageLogFileCnvrtCSV: MasterRolePermission = new MasterRolePermission("Manage Log File Cnvrt CSV");
   static ViewTestPage: MasterRolePermission = new MasterRolePermission("View AddOn Car Park");
  
  /*
  static RolePermissions: MasterRolePermission[] = [
    MasterRolePermission.ViewAlarmMonitor,
    MasterRolePermission.ViewOccupancy,
    MasterRolePermission.ViewParkingStations,
    MasterRolePermission.ViewANPRViewStreaming,
    MasterRolePermission.ViewGeolocalization,

    MasterRolePermission.ViewReportCreate,
    MasterRolePermission.ViewRepository,
    MasterRolePermission.ViewScheduling,

    MasterRolePermission.ViewCustomers,
    MasterRolePermission.ManageCustomers,
    MasterRolePermission.ViewProductProfiles,
    MasterRolePermission.ManageProductProfiles,
    MasterRolePermission.ViewTimeSlots,
    MasterRolePermission.ManageTimeSlots,
    MasterRolePermission.ViewGroup,
    MasterRolePermission.ManageGroup,
    MasterRolePermission.ViewRates,
    MasterRolePermission.ManageRates,
    MasterRolePermission.ViewAccessPolicies,
    MasterRolePermission.ManageAccessPolicies,
    MasterRolePermission.ViewBusinessCustomer,
    MasterRolePermission.ManageBusinessCustomer,
    MasterRolePermission.ViewRatesProfile,
    MasterRolePermission.ManageRatesProfile,
    MasterRolePermission.ViewUserCategory,
    MasterRolePermission.ManageUserCategory,
    MasterRolePermission.ViewCardPool,
    MasterRolePermission.ManageCardPool,
    MasterRolePermission.ViewVoucher,
    MasterRolePermission.ManageVoucher,
    MasterRolePermission.ViewDiscount,
    MasterRolePermission.ManageDiscount,
    MasterRolePermission.ViewOnlineBooking,
    MasterRolePermission.ManageOnlineBooking,
    MasterRolePermission.ViewAlerts,
    MasterRolePermission.ManageAlerts,
    MasterRolePermission.ViewParksFly,
    MasterRolePermission.ManageParksFly,
    MasterRolePermission.ViewBlackListWhiteList,
    MasterRolePermission.ManageBlackListWhiteList,
    MasterRolePermission.ViewStationGroup,
    MasterRolePermission.ManageStationGroup,

    MasterRolePermission.ViewSystem,
    MasterRolePermission.ManageSystem,
    MasterRolePermission.ViewLogs,
    MasterRolePermission.ManageLogs,
    MasterRolePermission.ViewAreaCount,
    MasterRolePermission.ManageAreaCount,
    MasterRolePermission.ViewDevices,
    MasterRolePermission.ManageDevices,
    MasterRolePermission.ViewUserOperators,
    MasterRolePermission.ManageUserOperators

    MasterRolePermission.ViewAccount,
    MasterRolePermission.ManageAccount
    MasterRolePermission.ViewContracts,
    MasterRolePermission.ManageContracts
    MasterRolePermission.ViewRoles,
    MasterRolePermission.ManageRoles

  ];*/

}
